import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Hook to track unsaved changes and prevent navigation
 */
export const useUnsavedChanges = (hasChanges: boolean) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    // Block navigation if there are unsaved changes
    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (hasChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [hasChanges]);

    /**
     * Check if user wants to navigate away with unsaved changes
     */
    const checkUnsavedChanges = useCallback((callback: () => void) => {
        if (hasChanges) {
            const confirmed = window.confirm(
                'Você tem alterações não salvas. Deseja sair sem salvar?'
            );
            if (confirmed) {
                callback();
            }
        } else {
            callback();
        }
    }, [hasChanges]);

    return {
        hasUnsavedChanges: hasChanges,
        checkUnsavedChanges
    };
};
